// material-ui
import { styled } from '@mui/material/styles';

// ===========================|| HORIZONTAL SCROLLER ||=========================== //

const ScrollX = styled('div')({
  width: '100%',
  overflowX: 'auto',
  display: 'block'
});

// ===========================|| VERTICAL SCROLLER ||=========================== //

export const ScrollY = styled('div')({
  width: '100%',
  height: '70vh', // 75% of the viewport height
  overflowY: 'auto',
  display: 'block'
});

export default ScrollX;
